import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddAmenitiesPageNew from "../../components/Amenities/AddAmenitiesPageNew";



const AddAmenitiesPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Amenities" link2="/amenities" title="Add Amenities" />

        {/* AddUserLayer */}
        <AddAmenitiesPageNew />


      </MasterLayout>
    </>
  );
};

export default AddAmenitiesPage;
